var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.showButton)?_c('div',{staticClass:"back-to-top-button",on:{"click":function($event){return _vm.goToTop()}}},[_c('i',{staticClass:"material-icons notranslate"},[_vm._v("expand_less")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }